import { render, staticRenderFns } from "./MediosComponent.vue?vue&type=template&id=767d72c4&"
import script from "./MediosComponent.vue?vue&type=script&lang=js&"
export * from "./MediosComponent.vue?vue&type=script&lang=js&"
import style0 from "./MediosComponent.vue?vue&type=style&index=0&id=767d72c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports